// As 11 chaves que substituíram o antigo "menu.configuracoes" único
// (ver backendprevidenciario/infraestructure/database/seedPermissoes.js,
// 2026-10-13) - uma por tela dentro do submenu "Configurações" da Sidebar.
export const CONFIGURACOES_KEYS = [
  'configuracoes.lembreteAtendimento',
  'configuracoes.lembretePresencial',
  'configuracoes.lembretePendencias',
  'configuracoes.lembretesTipos',
  'configuracoes.origens',
  'configuracoes.indicacoes',
  'configuracoes.beneficios',
  'configuracoes.advogados',
  'configuracoes.unidades',
  'configuracoes.vagasAtendimento',
  'configuracoes.painelChamados',
];

export default CONFIGURACOES_KEYS;
